export default "__VITE_ASSET__1a5aa359__"